import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { adminMe } from '../../api/news';

const AdminGate = ({ children }) => {
  const location = useLocation();
  const [state, setState] = useState({ loading: true, ok: false });

  useEffect(() => {
    let alive = true;
    adminMe()
      .then((d) => {
        if (alive) setState({ loading: false, ok: !!d.authenticated });
      })
      .catch(() => {
        if (alive) setState({ loading: false, ok: false });
      });
    return () => {
      alive = false;
    };
  }, [location.pathname]);

  if (state.loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#f5f5f3] text-[#555]">
        <p style={{ fontFamily: "'Montserrat', sans-serif" }}>Verificando sessão…</p>
      </div>
    );
  }

  if (!state.ok) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }

  return children;
};

export default AdminGate;
